import React from "react";

const WidgetNotFound = ({
  componentName,
}: {
  componentName?: string | null;
}) => {
  return <div>{componentName || "Widget"} Not Found</div>;
};

export default WidgetNotFound;
